import { hasValue, email, password, alphaSpace, minLength } from 'common/validations/field';
import i18n from 'i18n';

const validateRegisterForm = (values) => {
  const errors = {};

  if (!hasValue(values.first_name) || !minLength(values.first_name, 2)) {
    errors.first_name = i18n.t('emptyField', { ns: 'validations' });
  } else if (!alphaSpace(values.first_name)) {
    errors.first_name = i18n.t('alphaSpace', { ns: 'validations' });
  }

  if (!hasValue(values.last_name) || !minLength(values.last_name, 2)) {
    errors.last_name = i18n.t('emptyField', { ns: 'validations' });
  } else if (!alphaSpace(values.last_name)) {
    errors.last_name = i18n.t('alphaSpace', { ns: 'validations' });
  }

  if (!email(values.email)) {
    errors.email = i18n.t('email', { ns: 'validations' });
  }

  if (!hasValue(values.password)) {
    errors.password = i18n.t('emptyField', { ns: 'validations' });
  } else if (!password(values.password)) {
    errors.password = i18n.t('password', { ns: 'validations' });
  }

  if (!hasValue(values.password_confirmation)) {
    errors.password_confirmation = i18n.t('emptyField', { ns: 'validations' });
  } else if (values.password && values.password_confirmation !== values.password) {
    errors.password_confirmation = i18n.t('passwordMatch', { ns: 'validations' });
  }

  if (!values.birthdate) {
    errors.birthdate = i18n.t('emptyField', { ns: 'validations' });
  }

  if (!hasValue(values.gender)) {
    errors.gender = i18n.t('emptyField', { ns: 'validations' });
  }

  return errors;
};

export default validateRegisterForm;
